import { render, staticRenderFns } from "./FormChildInfo.vue?vue&type=template&id=594a6753&lang=pug&"
import script from "./FormChildInfo.vue?vue&type=script&lang=js&"
export * from "./FormChildInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports